import { Indicator, Stack, Text, Tooltip } from "@mantine/core"
import { SimpleWorkArea } from "../../../../../../@client/Theasoft_ApiServer_WorkAreas"
import { DepartmentContractDto } from "../../../../../../@client/Theasoft_ApiServer_Orchestra"
import css from "./cells.module.css"
import { match } from "ts-pattern"
import { MatrixOrientation } from "../matrix-css-grid"
import { Permission } from "../../../../../../@client/Theasoft_DataTypes_Enums"
import { SuspenseWithFallback } from "../../../../../../-components/suspense"
import { PersonName } from "@components/PersonName"
import { SimpleDutyRosterPeriod } from "@/@client/Theasoft_ApiServer_DutyRosterPeriods"
import { IconCircleOff } from "@tabler/icons-react"
import { HoverAndTouchTooltip } from "@/routes/app/-components/hover-and-touch-tooltip"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
// y dimesion (normal mode) are contracts or work areas
export type WorkareaOrContract =
  DataY_WorkArea | DataY_WorkareaStatus | DataY_Contract

type DataY_WorkArea = {
  type: "workarea"
  permission: Permission
  data: SimpleWorkArea
  workareaId: number
}

type DataY_WorkareaStatus = {
  type: "workarea-status"
  permission: Permission
  data: SimpleDutyRosterPeriod[]
  workareaId: number
  need: number | undefined
}

type DataY_Contract = {
  type: "contract"
  permission: Permission
  data: DepartmentContractDto
  workareaId: number
}

function PersonTooltip({ id }: { id: number }) {
  return (
    <SuspenseWithFallback>
      <PersonName personId={id} />
    </SuspenseWithFallback>
  )
}

export function WorkareaOrContractHeaderCell({
  y,
  orientation,
  rowIndex,
}: {
  y: WorkareaOrContract
  orientation: MatrixOrientation
  rowIndex: number
}) {
  const { t } = useTranslation("app_server")
  const className = match(y.type)
    .with("contract", () => "contract-header-cell")
    .with("workarea", () => "workarea-header-cell")
    .with("workarea-status", () => "workarea-header-cell")
    .exhaustive()
  return (
    <div
      className={clsx(
        css[className],
        y.type === "contract"
          ? rowIndex % 2 === 0
            ? css["even-row"]
            : css["odd-row"]
          : undefined
      )}
      style={{
        left: orientation == "normal" ? 0 : undefined,
        top: orientation == "transpose" ? 0 : undefined,
        borderBottom: orientation == "normal" ? "none" : undefined,
        borderRight: orientation == "transpose" ? "none" : undefined,
        background:
          y.type === "contract" && y.data.sort >= 1000
            ? `repeating-linear-gradient(
  45deg,
  var(--mantine-color-body),
  var(--mantine-color-body) 3px,
  var(--mantine-color-dark-light) 3px,
  var(--mantine-color-dark-light) 6px
)`
            : undefined,
      }}
    >
      {y.type == "contract" ? (
        <HoverAndTouchTooltip
          label={
            <div>
              <PersonTooltip id={y.data.person.personId} />
              <Text>{y.data.description}</Text>
            </div>
          }
        >
          <Indicator
            position="top-end"
            w={"100%"}
            disabled={!y.data.description.length}
            size={5}
          >
            <Text size={"xs"} fw={500} c="bright" truncate>
              {y.data.contractType.infoCode} {y.data.person.keyName}
            </Text>
          </Indicator>
        </HoverAndTouchTooltip>
      ) : (
        <HoverAndTouchTooltip
          disabled={y.type === "workarea-status"}
          label={y.type === "workarea-status" ? "" : y.data.name}
        >
          <Text
            size={"xs"}
            fw={700}
            tt="uppercase"
            fs="italic"
            c="bright"
            truncate
          >
            {y.type === "workarea-status" ? (
              <HoverAndTouchTooltip
                label={t("Orchestra_WorkAreasNeeds", { value: y.need })}
              >
                <Text>
                  {y.need} <IconCircleOff size={10} />
                </Text>
              </HoverAndTouchTooltip>
            ) : (
              y.data.name
            )}
          </Text>
        </HoverAndTouchTooltip>
      )}
    </div>
  )
}
